var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategyIconGreen1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 5.19995H26.8C27.1183 5.19995 27.4235 5.32638 27.6485 5.55142C27.8736 5.77647 28 6.08169 28 6.39995V25.6C28 25.9182 27.8736 26.2234 27.6485 26.4485C27.4235 26.6735 27.1183 26.8 26.8 26.8H5.2C4.88174 26.8 4.57652 26.6735 4.35147 26.4485C4.12643 26.2234 4 25.9182 4 25.6V6.39995C4 6.08169 4.12643 5.77647 4.35147 5.55142C4.57652 5.32638 4.88174 5.19995 5.2 5.19995V5.19995ZM6.4 7.59995V24.4H25.6V7.59995H6.4ZM10 17.2H12.4V22H10V17.2ZM14.8 9.99995H17.2V22H14.8V9.99995ZM19.6 13.6H22V22H19.6V13.6Z",
    fill: "#9A9A9A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 5.19995H26.8C27.1183 5.19995 27.4235 5.32638 27.6485 5.55142C27.8736 5.77647 28 6.08169 28 6.39995V25.6C28 25.9182 27.8736 26.2234 27.6485 26.4485C27.4235 26.6735 27.1183 26.8 26.8 26.8H5.2C4.88174 26.8 4.57652 26.6735 4.35147 26.4485C4.12643 26.2234 4 25.9182 4 25.6V6.39995C4 6.08169 4.12643 5.77647 4.35147 5.55142C4.57652 5.32638 4.88174 5.19995 5.2 5.19995V5.19995ZM6.4 7.59995V24.4H25.6V7.59995H6.4ZM10 17.2H12.4V22H10V17.2ZM14.8 9.99995H17.2V22H14.8V9.99995ZM19.6 13.6H22V22H19.6V13.6Z",
    fill: "url(#paint0_linear_740_3515)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_3515",
    x1: 16,
    y1: 5.19995,
    x2: 16,
    y2: 26.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34C759"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#008B1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyIconGreen1);
export default __webpack_public_path__ + "static/media/strategyIconGreen1.59fb3cf6d19e7bdf135e0fa8022b9763.svg";
export { ForwardRef as ReactComponent };